<template>
	<div class="wrapper-section">
		<div class="container-section contract">
			<div class="container-input">
				<div @click="collapsedDropdown = !collapsedDropdown" :class="{rounded: collapsedDropdown}" class="input-dropdown row centered space-between">
					<div class="title"><img src="https://img.qromo.io/img/icon-oder-analytics.svg" alt="icon contract"><p>{{ getString('read_the_contract') }}</p></div>
					<AppChevronIcon :direction="collapsedDropdown ? 'down' : 'up'" />
				</div>
				<AppDropdown :collapsed="collapsedDropdown">
					<iframe :src="COUNTRY === 'IT' ? '/terms/' : '/terms/en.php'"></iframe>
				</AppDropdown>
			</div>
		</div>
		<div class="container-section container-section-second" @click.stop="clickFirstCheckbox">
			<div class="container-input">
				<AppCheckbox :auto-toggle="false" :is-active="firstCheckboxFlagged" />
				<p>{{ getString('contract_accept_1') }}</p>
			</div>
		</div>
		<div class="container-section container-section-third" @click.stop="clickSecondCheckbox">
			<div class="container-input">
				<AppCheckbox :auto-toggle="false" :is-active="secondCheckboxFlagged" />
				<p>{{ getString('contract_accept_2') }}</p>
			</div>
		</div>
	</div>
</template>
<script>
import {useLanguageStore} from "@/shared/stores";
import AppNotification from "@/shared/components/AppNotification.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppCheckbox from "@/shared/components/AppCheckbox.vue";

export default {
	components: {AppNotification, AppDropdown, AppChevronIcon, AppCheckbox},
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	name: "TermsAndConditions",
	data() {
		return {
			collapsedDropdown: false,
			firstCheckboxFlagged: false,
			secondCheckboxFlagged: false,
			COUNTRY: COUNTRY,
		}
	},
	emits: ["contract-signed", "contract-unsigned"],
	props: {

	},
	methods: {
		clickFirstCheckbox() {
			this.firstCheckboxFlagged = !this.firstCheckboxFlagged;
			this.checkAndEmit();
		},
		clickSecondCheckbox() {
			this.secondCheckboxFlagged = !this.secondCheckboxFlagged;
			this.checkAndEmit();
		},
		checkAndEmit() {
			if(this.firstCheckboxFlagged && this.secondCheckboxFlagged) {
				this.$emit("contract-signed");
			} else {
				this.$emit("contract-unsigned");
			}
		},
		cancel() {
			this.firstCheckboxFlagged = false;
			this.secondCheckboxFlagged = false;
			this.$emit("contract-unsigned");
		}
	}
}
</script>
<style lang="scss" scoped>
.wrapper-section {
	.container-section {
		border: 1px solid var(--color-primary);
		border-radius: 13px;
		margin-bottom: 14px;
		background-color: var(--color-bg);
		padding: 16px;
		&:last-child {
			margin-bottom: 0;
		}
		.input-dropdown {
			cursor: pointer;
			overflow: hidden;
			transition: max-height .5s $transition;
			max-height: 50px;
			&.hidden {
				max-height: 0;
			}
		}
	}
	.contract {
		:deep(.dropdown-content) {
			background-color: var(--color-txt-white);
			padding: 0;
			iframe {
				width: 100%;
				height: 100%;
				border: none;
				min-height: 230px;
			}
		}
	}
	.container-input {
		p {
			font-size: 14px;
			line-height: 20px;
		}
	}
	.title {
		display: flex;
		align-items: center;
		pointer-events: none;
		p {
			font-style: italic;
			font-weight: bold;
			font-size: 16px;
			color: var(--color-primary);
		}
		img {
			width: 20px;
			height: 20px;
			margin-right: 10px;
		}
	}
	.container-section-second {
		cursor: pointer;
		user-select: none;

		.container-input {
			display: flex;
			align-items: center;
		}
		:deep(.label-container) {
			width: auto;
			.wrapper-row {
				width: 30px;
			}
			.checkmark {
				left: 0;
			}
		}
	}
	.container-section-third {
		cursor: pointer;
		user-select: none;

		.title {
			p {
				font-style: italic;
				font-weight: bold;
				font-size: 14px;
				color: #4e4e4e;
			}
		}
		.container-input {
			display: flex;
			align-items: center;
		}
		:deep(.label-container) {
			width: auto;
			.wrapper-row {
				width: 30px;
			}
			.checkmark {
				left: 0;
			}
		}
		:deep(.dropdown-container) {
			.dropdown.collapsed {
				max-height: 60px !important;
				visibility: unset;
				opacity: 1;
			}
			.dropdown-content {
				max-height: 500px;
				overflow: auto;
				margin-top: 0;
				padding: 0 10px 0 0;
				@media(max-width: 380px) {
					max-height: 700px;
					overflow: unset;
				}
			}
		}
	}
}
</style>